export default __webpack_public_path__ + "static/media/chery.d312052f.ico";